import { underscore } from 'inflected';

export default function({
  filters,
  orderBy,
  orderDirection,
  page,
  pageSize,
  search,
  size,
}) {
  const params = {
    page: page ? page + 1 : 1,
    per_page: pageSize || 5,
  };

  if (search)
    params.qs = search;

  if (size)
    params.size = size;

  if (filters && filters.length > 0)
    params.filters = filters;

  if (orderBy && orderDirection)
    params.sorter = `${underscore(orderBy.field)}.${orderDirection}`;

  return params;
}
